import { render, staticRenderFns } from "./McpMessageItem.vue?vue&type=template&id=2fd63c92&scoped=true"
import script from "./McpMessageItem.vue?vue&type=script&lang=js"
export * from "./McpMessageItem.vue?vue&type=script&lang=js"
import style0 from "./McpMessageItem.vue?vue&type=style&index=0&id=2fd63c92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd63c92",
  null
  
)

export default component.exports